<template lang="html">
  <nav aria-label="breadcrumb" class="breadcrumb">
    <v-container>
      <ol>
        <li v-for="step in steps" class="breadcrumb-item">
          <v-link v-if="step.to" :to="step.to">{{ step.label }}</v-link>
          <span v-else>{{ step.label }}</span>
        </li>
      </ol>
    </v-container>
  </nav>
</template>

<script>
export default {
  props: ['steps'],
};
</script>

<style lang="scss">
.breadcrumb {
  position: relative;
  background-color: white !important;

  ol {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      display: inline-block;
      a {
        color: black;
      }
      &:last-child {
        font-size: 16px;
        color: black;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/breadcrumb.vue